module.exports = __webpack_public_path__ + "img/recessed_point.0d742731.jpg";